
require("channels")

import KastioActionCable from 'KastioActionCable/index.js'
global.KastioActionCable = KastioActionCable
